import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';

/**
 * Component to redirect authenticated users away from auth pages
 * like login, register, and forgot-password
 */
const AuthRedirectRoute = ({ children }) => {
  const { currentUser, loading } = useContext(AuthContext);

  // If still loading auth status, show loading indicator
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // If user is authenticated, redirect to the appropriate dashboard
  if (currentUser) {
    console.log('AuthRedirectRoute: User already authenticated, redirecting to dashboard');
    
    // Determine the appropriate dashboard based on user role
    let dashboardPath;
    switch (currentUser.role) {
      case 'superadmin':
        dashboardPath = '/superadmin/dashboard';
        break;
      case 'admin':
        dashboardPath = currentUser.organization_domain 
          ? `/${currentUser.organization_domain}/admin/dashboard` 
          : '/admin/dashboard';
        break;
      case 'owner':
        dashboardPath = currentUser.organization_domain 
          ? `/${currentUser.organization_domain}/owner/dashboard` 
          : '/owner/dashboard';
        break;
      case 'guard':
        dashboardPath = currentUser.organization_domain 
          ? `/${currentUser.organization_domain}/guard/dashboard` 
          : '/guard/dashboard';
        break;
      case 'maintenance':
        dashboardPath = currentUser.organization_domain 
          ? `/${currentUser.organization_domain}/maintenance/dashboard` 
          : '/maintenance/dashboard';
        break;
      default:
        dashboardPath = '/landing';
    }
    
    return <Navigate to={dashboardPath} replace />;
  }

  // If not authenticated, render the children
  return children;
};

export default AuthRedirectRoute; 